<template>
  <div class="data-groups">
    <div class="header">
      <div class="header-controls">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane v-if="showAdminTab" label="数据组管理" name="admin"></el-tab-pane>
          <el-tab-pane v-if="showBuyerTab" label="买量站数据组 - 总" name="buyer"></el-tab-pane>
          <el-tab-pane v-if="showBuyerTab" label="cid域名数据" name="cid"></el-tab-pane>
          <el-tab-pane v-if="showBuyerTab" label="站点维护" name="site"></el-tab-pane>
        </el-tabs>
        <div class="control-buttons">
          <!-- 站点维护和CID的按钮 -->
          <template v-if="activeTab === 'site' || activeTab === 'cid'">
            <div style="flex: 1;"></div>
            <div class="site-action-container">
              <el-button type="primary" @click="handleAdd">新增</el-button>
            </div>
          </template>
          <!-- 其他tab的查询条件和按钮 -->
          <template v-else>
            <el-input
              v-model="sid"
              :placeholder="activeTab === 'admin' ? '搜索SID' : activeTab === 'buyer' ? '搜索站点URL' : '搜索站点URL'"
              clearable
              @clear="handleSearch"
              @keyup.enter.native="handleSearch"
              style="width: 200px"
            >
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
            <div>
              <el-button type="primary" @click="handleRemarkAdd" v-if="activeTab === 'buyer'">批量更改站点类型和备注</el-button>
              <el-button type="primary" @click="handleAdd">{{ activeTab === 'admin' ? '新增数据组' : activeTab === 'buyer' ? '新增买量站数据组 - 总' : '新增cid域名数据' }}</el-button>
              <el-button 
                v-if="activeTab === 'buyer' && (isAdmin || isSecondaryAdmin)" 
                type="success" 
                @click="handleBatchUpdateCreator">
                批量更新所属人
              </el-button>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <!-- 正常数据组表格 -->
      <el-table
        v-if="activeTab === 'admin'"
        v-loading="storeLoading"
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column prop="sid" label="SID"></el-table-column>
        <el-table-column prop="platformType" label="平台">
          <template slot-scope="scope">
            {{ scope.row.platformType || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 买量站数据组表格 -->
      <el-table
        v-if="activeTab === 'buyer'"
        v-loading="buyingSiteLoading"
        :data="buyingSiteGroups"
        border
        style="width: 100%">
        <el-table-column prop="webSiteUrl" label="站点URL"></el-table-column>
        <el-table-column prop="childWebSiteList" label="子域名" width="180">
          <template slot-scope="scope">
            {{ getSubdomains(scope.row.childWebSiteList) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleBuyingSiteEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              type="danger"
              size="small"
              @click="handleBuyingSiteDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分cid域名数据权限表格 -->
      <el-table
        v-if="activeTab === 'cid'"
        v-loading="cidLoading"
        :data="cidGroups"
        border
        style="width: 100%">
        <el-table-column prop="webSiteUrl" label="站点"></el-table-column>
        <el-table-column prop="channelIds" label="已添加">
          <template slot-scope="scope">
            {{ scope.row.channelIds || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleCidEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleCidDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 站点维护表格 -->
      <el-table
        v-if="activeTab === 'site'"
        v-loading="siteLoading"
        :data="siteMappingList"
        border
        style="width: 100%">
        <el-table-column prop="webSiteUrl" label="站点名称"></el-table-column>
        <el-table-column prop="fakeWebSiteUrl" label="伪装域名"></el-table-column>
        <el-table-column prop="advertiserIds" label="账户ID">
          <template slot-scope="scope">
            {{ scope.row.advertiserIds || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="录入人"></el-table-column>
        <el-table-column prop="createTime" label="录入时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleSiteEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleSiteDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增数据组对话框 -->
    <el-dialog
      :title="dialogType === 'add' ? '新增数据组' : '编辑数据组'"
      :visible.sync="dialogVisible"
      width="30%"
      @close="resetForm">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="SID" prop="sid">
          <el-input 
            v-model.trim="form.sid" 
            :disabled="dialogType === 'edit'"
            placeholder="请输入SID">
          </el-input>
        </el-form-item>
        <el-form-item label="平台" prop="platforms">
          <el-checkbox-group v-model="form.platforms">
            <el-checkbox label="tiktok" value="tiktok">TikTok</el-checkbox>
            <el-checkbox label="fb" value="fb">FB</el-checkbox>
            <el-checkbox label="kwai" value="kwai">KWai</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增买量站数据组对话框 -->
    <el-dialog
      :title="buyingSiteDialogType === 'add' ? '新增买量站数据组 - 总' : '编辑买量站数据组 - 总'"
      :visible.sync="buyingSiteDialogVisible"
      width="50%"
      @close="resetBuyingSiteForm">
      <el-form :model="buyingSiteForm" :rules="buyingSiteRules" ref="buyingSiteForm" label-width="90px">
        <el-form-item label="站点URL" prop="webSiteUrl">
          <el-input 
            v-model.trim="buyingSiteForm.webSiteUrl" 
            placeholder="请输入站点URL">
          </el-input>
        </el-form-item>
        <el-form-item label="子域名配置">
          <div v-for="(item, index) in buyingSiteForm.domainChannelList" :key="index" style="display: flex; align-items: center; margin-bottom: 10px;">
            <el-input 
              v-model.trim="item.domain" 
              placeholder="请输入子域名"
              style="width: 200px; margin-right: 10px;">
            </el-input>
            <el-input 
              v-model.trim="item.channel" 
              placeholder="请输入channel"
              style="width: 200px; margin-right: 10px;">
            </el-input>
            <el-button 
              type="danger" 
              size="small" 
              icon="el-icon-delete"
              @click="removeDomainChannel(index)">
            </el-button>
          </div>
          <el-button 
            type="primary" 
            size="small" 
            icon="el-icon-plus"
            @click="addDomainChannel">
            添加子域名配置
          </el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="buyingSiteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBuyingSiteSubmit" :loading="buyingSiteSubmitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量更新所属人对话框 -->
    <el-dialog
      title="批量更新所属人"
      :visible.sync="batchUpdateDialogVisible"
      width="40%"
      @close="resetBatchUpdateForm">
      <el-form :model="batchUpdateForm" :rules="batchUpdateRules" ref="batchUpdateForm" label-width="80px">
        <el-form-item label="站点URL" prop="webSiteUrl">
          <el-input 
            type="textarea"
            :rows="4"
            v-model.trim="batchUpdateForm.webSiteUrl" 
            placeholder="请输入站点URL，多个站点用英文逗号分隔">
          </el-input>
        </el-form-item>
        <el-form-item label="所属人" prop="creator">
          <el-select 
            v-model="batchUpdateForm.creator" 
            placeholder="请选择所属人"
            multiple
            style="width: 100%">
            <el-option
              v-for="account in accountList"
              :key="account.accountId"
              :label="account.accountName"
              :value="account.accountName">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchUpdateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchUpdateSubmit" :loading="batchUpdateSubmitting">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 批量更新所属人对话框 -->
    <el-dialog
      title="批量更新分类和备注"
      :visible.sync="remarkDialogVisible"
      width="40%"
      @close="resetBatchUpdateForm">
      <el-form :model="batchUpdateForm" :rules="batchRemarkUpdateRules" ref="batchUpdateForm" label-width="80px">
        <el-form-item label="站点URL" prop="webSiteUrl">
          <el-input 
            type="textarea"
            :rows="4"
            v-model.trim="batchUpdateForm.webSiteUrl" 
            placeholder="请输入站点URL，多个站点用英文逗号分隔">
          </el-input>
        </el-form-item>
        <el-form-item label="分类" prop="categoryName">
          <el-select 
            v-model="batchUpdateForm.categoryName" 
            placeholder="请选择分类"
            style="width: 100%">
            <el-option
              v-for="account in categoryNameList"
              :key="account"
              :label="account"
              :value="account">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input 
            type="textarea"
            :rows="4"
            v-model.trim="batchUpdateForm.remarks" 
            placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchRemarkUpdateSubmit" :loading="batchUpdateSubmitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增分cid域名数据权限对话框 -->
    <el-dialog
      title="新增分cid域名数据权限"
      :visible.sync="cidDialogVisible"
      :close-on-click-modal="false"
      width="70%"
      @close="resetCidForm">
      <el-table
        :data="cidAddForm.items"
        border
        style="width: 100%"
        :row-class-name="getCidAddRowClassName"
        :cell-class-name="getCidAddCellClassName">
        <el-table-column prop="webSiteUrl" label="站点名称">
          <template slot-scope="scope">
            <div class="input-wrapper input-with-error">
              <el-input 
                v-model.trim="scope.row.webSiteUrl" 
                placeholder="请输入站点名称"
                :class="{ 'invalid-input': scope.row.isInvalid }">
              </el-input>
              <div v-if="scope.row.isInvalid" class="invalid-reason inline-error">{{ scope.row.invalidReason }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="channelId" label="自定义渠道ID">
          <template slot-scope="scope">
            <el-input 
              v-model.trim="scope.row.channelId" 
              placeholder="请输入自定义渠道ID"
              :class="{ 'invalid-input': scope.row.isInvalid }">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="small"
              @click="removeCidAddItem(scope.$index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: center;">
        <el-button type="primary" @click="addCidAddItem(1)">在下方插入一行</el-button>
        <el-button type="primary" @click="addCidAddItem(5)">在下方插入五行</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cidDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCidAddSubmit" :loading="cidSubmitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑分cid域名数据权限对话框 -->
    <el-dialog
      title="编辑"
      :visible.sync="cidEditDialogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="resetCidEditForm">
      <el-form :model="cidEditForm" :rules="cidEditRules" ref="cidEditForm" label-width="120px">
        <el-table
          :data="cidEditForm.items"
          border
          style="width: 100%"
          :row-class-name="getCidEditRowClassName"
          :cell-class-name="getCidEditCellClassName">
          <el-table-column prop="webSiteUrl" label="站点名称">
            <template slot-scope="scope">
              <div class="input-wrapper input-with-error">
                <el-input 
                  v-model.trim="scope.row.webSiteUrl" 
                  :disabled="true"
                  placeholder="请输入站点名称"
                  :class="{ 'invalid-input': scope.row.isInvalid }">
                </el-input>
                <div v-if="scope.row.isInvalid" class="invalid-reason inline-error">{{ scope.row.invalidReason }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="channelId" label="自定义渠道ID">
            <template slot-scope="scope">
              <el-input 
                v-model.trim="scope.row.channelId" 
                placeholder="请输入自定义渠道ID"
                :class="{ 'invalid-input': scope.row.isInvalid }">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="small"
                @click="removeCidEditItem(scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div style="margin-top: 15px; text-align: center;">
        <el-button type="primary" @click="addCidEditItem(1)">新增一列</el-button>
        <el-button type="primary" @click="addCidEditItem(5)">新增五列</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cidEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCidEditSubmit" :loading="cidEditSubmitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增站点映射关系对话框 -->
    <el-dialog
      title="新增站点映射关系"
      :visible.sync="siteAddDialogVisible"
      :close-on-click-modal="false"
      width="70%"
      @close="resetSiteAddForm">
      <el-table
        :data="siteAddForm.items"
        border
        style="width: 100%"
        :row-class-name="getSiteAddRowClassName"
        :cell-class-name="getSiteAddCellClassName">
        <el-table-column prop="webSiteUrl" label="站点名称">
          <template slot-scope="scope">
            <div class="input-wrapper input-with-error">
              <el-input 
                v-model.trim="scope.row.webSiteUrl" 
                placeholder="请输入站点名称"
                :class="{ 'invalid-input': scope.row.isInvalid }">
              </el-input>
              <div v-if="scope.row.isInvalid" class="invalid-reason inline-error">{{ scope.row.invalidReason }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fakeWebSiteUrl" label="伪装域名">
          <template slot-scope="scope">
            <el-input 
              v-model.trim="scope.row.fakeWebSiteUrl" 
              placeholder="请输入伪装域名"
              :class="{ 'invalid-input': scope.row.isInvalid }">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="advertiserId" label="账户ID">
          <template slot-scope="scope">
            <el-input 
              v-model.trim="scope.row.advertiserId" 
              placeholder="请输入账户ID"
              :class="{ 'invalid-input': scope.row.isInvalid }">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="small"
              @click="removeSiteAddItem(scope.$index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: center;">
        <el-button type="primary" @click="addSiteAddItem(1)">在下方插入一行</el-button>
        <el-button type="primary" @click="addSiteAddItem(5)">在下方插入五行</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="siteAddDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSiteAddSubmit" :loading="siteAddSubmitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑站点映射关系对话框 -->
    <el-dialog
      title="编辑"
      :visible.sync="siteEditDialogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="resetSiteEditForm">
      <el-form :model="siteEditForm" :rules="siteEditRules" ref="siteEditForm" label-width="120px">
        <el-table
          :data="siteEditForm.items"
          border
          style="width: 100%"
          :row-class-name="getSiteEditRowClassName"
          :cell-class-name="getSiteEditCellClassName">
          <el-table-column prop="webSiteUrl" label="站点名称">
            <template slot-scope="scope">
              <div class="input-wrapper input-with-error">
                <el-input 
                  v-model.trim="scope.row.webSiteUrl" 
                  :disabled="true"
                  placeholder="请输入站点名称"
                  :class="{ 'invalid-input': scope.row.isInvalid }">
                </el-input>
                <div v-if="scope.row.isInvalid" class="invalid-reason inline-error">{{ scope.row.invalidReason }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="fakeWebSiteUrl" label="伪装域名">
            <template slot-scope="scope">
              <el-input 
                v-model.trim="scope.row.fakeWebSiteUrl" 
                placeholder="请输入伪装域名"
                :class="{ 'invalid-input': scope.row.isInvalid }">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="advertiserId" label="账户ID">
            <template slot-scope="scope">
              <el-input 
                v-model.trim="scope.row.advertiserId" 
                placeholder="请输入账户ID"
                :class="{ 'invalid-input': scope.row.isInvalid }">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="small"
                @click="removeSiteEditItem(scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div style="margin-top: 15px; text-align: center;">
        <el-button type="primary" @click="addSiteEditItem(1)">新增一列</el-button>
        <el-button type="primary" @click="addSiteEditItem(5)">新增五列</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="siteEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSiteEditSubmit" :loading="siteEditSubmitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'DataGroups',
    data() {
      return {
        activeTab: 'admin',
        sid: '',
        dialogVisible: false,
        submitting: false,
        pageNum: 1,
        pageSize: 10,
        remarkDialogVisible: false,
        total: 0,
        form: {
          sid: '',
          platforms: []
        },
        rules: {
          sid: [
            { required: true, message: '请输入SID', trigger: 'blur' },
            { pattern: /^\d+$/, message: 'SID必须为数字', trigger: 'blur' }
          ]
        },
        dialogType: 'add',
        editingId: null,
        tableData: [],
        buyingSiteGroups: [],
        buyingSiteLoading: false,
        buyingSiteDialogVisible: false,
        buyingSiteSubmitting: false,
        buyingSiteForm: {
          webSiteUrl: '',
          domainChannelList: []
        },
        buyingSiteRules: {
          webSiteUrl: [
            { required: true, message: '请输入站点URL', trigger: 'blur' }
          ]
        },
        // 批量更新所属人相关数据
        batchUpdateDialogVisible: false,
        batchUpdateSubmitting: false,
        batchUpdateForm: {
          webSiteUrl: '',
          creator: [],
          categoryName: '',
          remarks: ''
        },
        batchUpdateRules: {
          webSiteUrl: [
            { required: true, message: '请输入站点URL', trigger: 'blur' }
          ],
          creator: [
            { required: true, message: '请选择所属人', trigger: 'change' }
          ]
        },
        batchRemarkUpdateRules: {
          webSiteUrl: [
            { required: true, message: '请输入站点URL', trigger: 'blur' }
          ],
        },
        buyingSiteDialogType: 'add', // 新增或编辑
        // 分cid域名数据权限相关数据
        cidGroups: [],
        cidLoading: false,
        cidDialogVisible: false,
        cidSubmitting: false,
        cidEditDialogVisible: false,
        cidEditSubmitting: false,
        categoryNameList: [],
        cidAddForm: {
          items: []
        },
        cidEditForm: {
          webSiteUrl: '',
          items: []
        },
        cidEditRules: {},
        editingCidWebSiteUrl: null,
        // 站点维护相关数据
        siteMappingList: [],
        siteLoading: false,
        siteAddDialogVisible: false,
        siteAddSubmitting: false,
        siteAddForm: {
          items: []
        },
        siteEditDialogVisible: false,
        siteEditSubmitting: false,
        siteEditForm: {
          id: null,
          items: []
        },
        siteEditRules: {},
        editingSiteMappingId: null
      }
    },
    computed: {
      ...mapState('user', ['userType', 'isSecondaryAdmin']),
      isAdmin() {
        return this.$store.state.user.isAdmin
      },
      dataGroups() {
        return this.$store.state.dataGroups.dataGroups
      },
      storeLoading() {
        return this.$store.state.dataGroups.loading
      },
      storeTotal() {
        return this.$store.state.dataGroups.total
      },
      showAdminTab() {
        return this.userType == 1 || this.userType == '1,2'
      },
      showBuyerTab() {
        return this.userType == 2 || this.userType == '1,2'
      },
      accountList() {
        return this.$store.state.dataGroups.accountList
      }
    },
    methods: {
      async fetchCategoryNameList() {
        const response = await this.$store.dispatch('dataGroups/getCategoryNameList')
        this.categoryNameList = response || []
      },
      handleRemarkAdd() {
        this.remarkDialogVisible = true
      },
      getSubdomains(data) {
        if (!data || !data.length) {
          return ""
        }

        return data.map(item => item.domain).join(',')
      },
      formatDate(date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
      async fetchData() {
        this.loading = true
        try {
          const response = await this.$http.get('/launch/data/group/list', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              sid: this.sid,
              type: this.activeTab === 'admin' ? 'admin' : 'buyer'
            }
          })

          if (response.data.header.code === 0) {
            this.tableData = response.data.body.data
            this.total = response.data.body.total
          } else {
            this.$message.error(response.data.header.msg || '获取数据失败')
          }
        } catch (error) {
          this.$message.error(error.message || '获取数据失败')
        } finally {
          this.loading = false
        }
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.pageNum = 1  // 切换每页显示数量时重置为第一页
        if (this.activeTab === 'buyer') {
          this.fetchBuyingSiteGroups()
        } else if (this.activeTab === 'cid') {
          this.fetchCidGroups()
        } else if (this.activeTab === 'site') {
          this.fetchSiteMappingList()
        } else {
          this.fetchData()
        }
      },
      handleCurrentChange(val) {
        this.pageNum = val
        if (this.activeTab === 'buyer') {
          this.fetchBuyingSiteGroups()
        } else if (this.activeTab === 'cid') {
          this.fetchCidGroups()
        } else if (this.activeTab === 'site') {
          this.fetchSiteMappingList()
        } else {
          this.fetchData()
        }
      },
      resetForm() {
        this.$refs.form?.resetFields()
        this.form.sid = ''
        this.form.platforms = []
        this.dialogType = 'add'
        this.editingId = null
      },
      async handleSubmit() {
        try {
          await this.$refs.form.validate()
          this.submitting = true

          // 转换平台名称为后端需要的格式
          const platformType = this.form.platforms.map(p => p.toLowerCase())

          if (this.dialogType === 'add') {
            await this.$store.dispatch('dataGroups/createDataGroup', {
              sid: this.form.sid,
              platformType
            })
          } else {
            await this.$store.dispatch('dataGroups/updateDataGroup', {
              sid: this.editingId,
              platformType
            })
          }

          this.$message.success(this.dialogType === 'add' ? '创建成功' : '更新成功')
          this.dialogVisible = false
          this.resetForm()
          await this.fetchData()
        } catch (error) {
          this.$message.error(error.toString())
        } finally {
          this.submitting = false
        }
      },
      async handleDelete(row) {
        try {
          await this.$confirm('确认删除该数据组吗？', '提示', {
            type: 'warning'
          })

          await this.$store.dispatch('dataGroups/deleteDataGroup', row.sid)
          this.$message.success('删除成功')
          // 如果当前页只有一条数据且不是第一页，删除后自动跳转到上一页
          if (this.dataGroups.length === 1 && this.pageNum > 1) {
            this.pageNum--
          }
          await this.fetchData()
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error(error.toString())
          }
        }
      },
      async handleSearch() {
        this.pageNum = 1
        this.total = 0;
        if (this.activeTab === 'buyer') {
          this.fetchBuyingSiteGroups()
        } else if (this.activeTab === 'cid') {
          this.fetchCidGroups()
        } else if (this.activeTab === 'site') {
          this.fetchSiteMappingList()
        } else {
          this.fetchData()
        }
      },
      formatPlatforms(platforms) {
        if (!platforms || !platforms.length) return '-'
        const platformMap = {
          'tt': 'tiktok',
          'fb': 'fb',
          'kwai': 'kwai'
        }
        return platforms.map(p => platformMap[p] || p).join(', ')
      },
      handleEdit(row) {
        this.dialogType = 'edit'
        this.editingId = row.sid
        this.form.sid = row.sid
        // 转换平台名称
        const platformMap = {
          'TIKTOK': 'tiktok',
          'FACEBOOK': 'fb',
          'FB': 'fb',
          'KWAI': 'kwai'
        }
        this.form.platforms = row.platformType ?
          row.platformType.split(',').map(p => platformMap[p.toUpperCase()] || p.toLowerCase()) : []
        this.dialogVisible = true
      },
      handleTabClick() {
        this.pageNum = 1
        this.total = 0;
        this.sid = ''
        if (this.activeTab === 'buyer') {
          this.fetchBuyingSiteGroups()
        } else if (this.activeTab === 'cid') {
          this.fetchCidGroups()
        } else if (this.activeTab === 'site') {
          this.fetchSiteMappingList()
        } else {
          this.fetchData()
        }
      },
      async fetchBuyingSiteGroups() {
        try {
          console.log('开始加载买量站数据')
          this.buyingSiteLoading = true
          const response = await this.$http.get('/launch/buy/data/group/list', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              webSiteUrl: this.sid || undefined
            }
          })
          console.log('买量站数据加载成功:', response.data.body.data)
          this.buyingSiteGroups = response.data.body.data
          this.total = response.data.body.total
        } catch (error) {
          console.error('买量站数据加载失败:', error)
          this.$message.error(error.toString())
        } finally {
          this.buyingSiteLoading = false
        }
      },
      resetBuyingSiteForm() {
        this.$refs.buyingSiteForm?.resetFields()
        this.buyingSiteForm.webSiteUrl = ''
        this.buyingSiteForm.domainChannelList = [] // 重置子域名配置列表
        this.buyingSiteDialogType = 'add' // 重置对话框类型为新增
      },
      async handleBuyingSiteSubmit() {
        try {
          await this.$refs.buyingSiteForm.validate()
          this.buyingSiteSubmitting = true

          // 转换子域名配置为后端需要的格式
          const domainChannelList = this.buyingSiteForm.domainChannelList.map(item => ({
            domain: item.domain,
            channel: item.channel
          }));

          if (this.buyingSiteDialogType === 'edit') {
            // 编辑模式 - 调用更新接口
            await this.$http.post('/launch/buy/data/group/update', {
              childWebSiteChannelMappingList: domainChannelList,
              webSiteUrl: this.buyingSiteForm.webSiteUrl
            })

            this.$message.success('更新成功')
          } else {
            // 新增模式 - 调用保存接口
            await this.$http.post('/launch/buy/data/group/save', {
              webSiteUrl: this.buyingSiteForm.webSiteUrl,
              childWebSiteChannelMappingList: domainChannelList
            })
            this.$message.success('创建成功')
          }

          this.buyingSiteDialogVisible = false
          this.resetBuyingSiteForm()
          await this.fetchBuyingSiteGroups()
        } catch (error) {
          this.$message.error(error.toString())
        } finally {
          this.buyingSiteSubmitting = false
        }
      },
      async handleBuyingSiteDelete(row) {
        try {
          await this.$confirm('确认删除该买量站数据组吗？', '提示', {
            type: 'warning'
          })

          await this.$http.post('/launch/buy/data/group/remove', {
          }, {
            params: {
              webSiteUrl: row.webSiteUrl
            }
          })

          this.$message.success('删除成功')
          if (this.buyingSiteGroups.length === 1 && this.pageNum > 1) {
            this.pageNum--
          }
          await this.fetchBuyingSiteGroups()
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error(error.toString())
          }
        }
      },
      handleAdd() {
        if (this.activeTab === 'admin') {
          this.dialogVisible = true
        } else if (this.activeTab === 'buyer') {
          this.buyingSiteDialogVisible = true
          this.buyingSiteDialogType = 'add' // 新增买量站数据组
          this.resetBuyingSiteForm() // 重置表单
        } else if (this.activeTab === 'cid') {
          this.cidDialogVisible = true
          this.resetCidForm() // 重置表单
        } else if (this.activeTab === 'site') {
          this.siteAddDialogVisible = true
          this.resetSiteAddForm() // 重置表单
        }
      },
      async handleBuyingSiteEdit(row) {
        try {
          this.buyingSiteDialogType = 'edit'
          this.buyingSiteDialogVisible = true

          // 获取详情数据
          const response = await this.$http.get('/launch/buy/data/group/detail', {
            params: {
              webSiteUrl: row.webSiteUrl
            }
          })

          if (response.data.header.code === 0) {
            if (response.data.body.data) {
              const detail = response.data.body.data
              this.buyingSiteForm.webSiteUrl = detail.webSiteUrl
              // 将 childWebSiteList 转换为 domainChannelList 格式
              this.buyingSiteForm.domainChannelList = detail.childWebSiteList || []
            }
          } else {
            this.$message.error('获取详情失败')
          }
        } catch (error) {
          this.$message.error('获取详情失败：' + error.toString())
        }
      },
      addDomainChannel() {
        this.buyingSiteForm.domainChannelList.push({ domain: '', channel: '' });
      },
      removeDomainChannel(index) {
        this.buyingSiteForm.domainChannelList.splice(index, 1);
      },
      // 批量更新所属人相关方法
      async handleBatchUpdateCreator() {
        try {
          // 获取账号列表
          await this.$store.dispatch('dataGroups/fetchAccountList')
          this.batchUpdateDialogVisible = true
        } catch (error) {
          this.$message.error('获取账号列表失败：' + (error.toString()))
        }
      },
      resetBatchUpdateForm() {
        this.$refs.batchUpdateForm?.resetFields()
        this.batchUpdateForm.webSiteUrl = ''
        this.batchUpdateForm.creator = []
      },
      async handleBatchRemarkUpdateSubmit() {
        await this.$refs.batchUpdateForm.validate()
        this.batchUpdateSubmitting = true
        await this.$store.dispatch('dataGroups/setRemarkWebSiteUrl', {
          webSiteUrl: this.batchUpdateForm.webSiteUrl,
          categoryName: this.batchUpdateForm.categoryName,
          remarks: this.batchUpdateForm.remarks
        })

        this.$message.success('批量更新分类和备注成功')
        this.remarkDialogVisible = false
        this.resetBatchUpdateForm()
        // 刷新买量站数据组列表
        await this.fetchBuyingSiteGroups()
      },
      async handleBatchUpdateSubmit() {
        try {
          await this.$refs.batchUpdateForm.validate()
          this.batchUpdateSubmitting = true

          await this.$store.dispatch('dataGroups/updateDataGroupCreator', {
            webSiteUrl: this.batchUpdateForm.webSiteUrl,
            creator: this.batchUpdateForm.creator
          })

          this.$message.success('批量更新所属人成功')
          this.batchUpdateDialogVisible = false
          this.resetBatchUpdateForm()
          // 刷新买量站数据组列表
          await this.fetchBuyingSiteGroups()
        } catch (error) {
          this.$message.error('批量更新失败：' + (error.toString()))
        } finally {
          this.batchUpdateSubmitting = false
        }
      },
      // 分cid域名数据权限相关方法
      async fetchCidGroups() {
        try {
          console.log('开始加载分cid域名数据')
          this.cidLoading = true
          const response = await this.$http.get('/launch/buy/data/group/cid/list', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              webSiteUrl: this.sid || undefined
            }
          })
          console.log('分cid域名数据加载成功:', response.data.body.data)
          this.cidGroups = response.data.body.data
          this.total = response.data.body.total
        } catch (error) {
          console.error('分cid域名数据加载失败:', error)
          this.$message.error(error.toString())
        } finally {
          this.cidLoading = false
        }
      },
      resetCidForm() {
        this.cidAddForm.items = [{ webSiteUrl: '', channelId: '', isInvalid: false, invalidReason: '' }]
      },
      addCidAddItem(count) {
        for (let i = 0; i < count; i++) {
          this.cidAddForm.items.push({
            webSiteUrl: '',
            channelId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      removeCidAddItem(index) {
        this.cidAddForm.items.splice(index, 1)
        // 如果删除后没有数据了，至少保留一行
        if (this.cidAddForm.items.length === 0) {
          this.cidAddForm.items.push({
            webSiteUrl: '',
            channelId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      getCidAddRowClassName({ row, rowIndex }) {
        return row.isInvalid ? 'invalid-row' : ''
      },
      getCidAddCellClassName({ row, column, rowIndex, columnIndex }) {
        if (row.isInvalid) {
          return 'invalid-cell'
        }
        return ''
      },
      async handleCidAddSubmit() {
        try {
          // 校验数据
          const validItems = this.cidAddForm.items.filter(item =>
            item.webSiteUrl && item.channelId
          )

          if (validItems.length === 0) {
            this.$message.error('请至少填写一条完整的映射关系（站点名称和自定义渠道ID为必填项）')
            return
          }

          // 检查是否有未填写完整的行
          const incompleteItems = this.cidAddForm.items.filter(item =>
            (item.webSiteUrl || item.channelId) &&
            (!item.webSiteUrl || !item.channelId)
          )

          if (incompleteItems.length > 0) {
            this.$message.error('请填写完整的站点名称和自定义渠道ID')
            return
          }

          this.cidSubmitting = true

          // 按站点分组
          const groupedBySite = {}
          validItems.forEach(item => {
            const webSiteUrl = item.webSiteUrl.trim()
            if (!groupedBySite[webSiteUrl]) {
              groupedBySite[webSiteUrl] = []
            }
            groupedBySite[webSiteUrl].push({
              webSiteUrl: webSiteUrl,
              channelId: item.channelId.trim()
            })
          })

          // 批量提交，每个站点一个请求
          for (const webSiteUrl in groupedBySite) {
            const webSiteChannelMappingList = groupedBySite[webSiteUrl]
            await this.$http.post('/launch/buy/data/group/cid/save', {
              webSiteUrl: webSiteUrl,
              webSiteChannelMappingList: webSiteChannelMappingList
            }, {
              params: {
                webSiteUrl: webSiteUrl
              }
            })
          }

          this.$message.success(`成功新增 ${Object.keys(groupedBySite).length} 个站点的分cid域名数据权限`)
          this.cidDialogVisible = false
          this.resetCidForm()
          await this.fetchCidGroups()
        } catch (error) {
          this.$message.error(error.response?.data?.header?.msg || error.message || '新增失败')
        } finally {
          this.cidSubmitting = false
        }
      },
      async handleCidEdit(row) {
        try {
          this.editingCidWebSiteUrl = row.webSiteUrl
          this.cidEditDialogVisible = true

          // 获取详情数据
          const response = await this.$http.get('/launch/buy/data/group/cid/detail', {
            params: {
              webSiteUrl: row.webSiteUrl
            }
          })

          if (response.data.header.code === 0) {
            const detailData = response.data.body.data || []
            this.cidEditForm.webSiteUrl = row.webSiteUrl
            this.cidEditForm.items = detailData.map(item => ({
              webSiteUrl: item.webSiteUrl,
              channelId: item.channelId,
              isInvalid: false,
              invalidReason: ''
            }))
          } else {
            this.$message.error(response.data.header.msg || '获取详情失败')
          }
        } catch (error) {
          this.$message.error(error.toString() || '获取详情失败')
        }
      },
      removeCidEditItem(index) {
        this.cidEditForm.items.splice(index, 1)
        // 如果删除后没有数据了，至少保留一行
        if (this.cidEditForm.items.length === 0) {
          this.cidEditForm.items.push({
            webSiteUrl: this.cidEditForm.webSiteUrl,
            channelId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      addCidEditItem(count) {
        // 获取第一条数据的站点名称
        const webSiteUrl = this.cidEditForm.webSiteUrl || ''

        for (let i = 0; i < count; i++) {
          this.cidEditForm.items.push({
            webSiteUrl: webSiteUrl,
            channelId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      resetCidEditForm() {
        this.$refs.cidEditForm?.resetFields()
        this.cidEditForm.webSiteUrl = ''
        this.cidEditForm.items = []
        this.editingCidWebSiteUrl = null
      },
      getCidEditRowClassName({ row, rowIndex }) {
        return row.isInvalid ? 'invalid-row' : ''
      },
      getCidEditCellClassName({ row, column, rowIndex, columnIndex }) {
        if (row.isInvalid) {
          return 'invalid-cell'
        }
        return ''
      },
      async handleCidEditSubmit() {
        try {
          // 校验：编辑时只允许输入同一站点名称
          if (this.cidEditForm.items.length === 0) {
            this.$message.error('至少需要保留一条映射关系')
            return
          }

          const webSiteUrls = this.cidEditForm.items.map(item => item.webSiteUrl).filter(url => url)
          const uniqueWebSiteUrls = [...new Set(webSiteUrls)]

          if (uniqueWebSiteUrls.length > 1) {
            this.$message.error('编辑时只允许输入同一站点名称')
            return
          }

          if (webSiteUrls.length === 0) {
            this.$message.error('请输入站点名称')
            return
          }

          // 校验必填字段
          for (const item of this.cidEditForm.items) {
            if (!item.webSiteUrl || !item.channelId) {
              this.$message.error('请填写完整的站点名称和自定义渠道ID')
              return
            }
          }

          this.cidEditSubmitting = true

          // 准备提交的数据
          const webSiteChannelMappingList = this.cidEditForm.items.map(item => ({
            webSiteUrl: item.webSiteUrl.trim(),
            channelId: item.channelId.trim()
          }))

          const response = await this.$http.post('/launch/buy/data/group/cid/update', {
            webSiteUrl: this.cidEditForm.webSiteUrl,
            webSiteChannelMappingList: webSiteChannelMappingList
          }, {
            params: {
              webSiteUrl: this.cidEditForm.webSiteUrl
            }
          })

          if (response.data.header.code === 0) {
            this.$message.success('更新成功')
            this.cidEditDialogVisible = false
            this.resetCidEditForm()
            await this.fetchCidGroups()
          } else {
            this.$message.error(response.data.header.msg || '更新失败')
          }
        } catch (error) {
          this.$message.error(error.response?.data?.header?.msg || error.message || '更新失败')
        } finally {
          this.cidEditSubmitting = false
        }
      },
      async handleCidDelete(row) {
        try {
          await this.$confirm('确认删除该分cid域名数据权限吗？', '提示', {
            type: 'warning'
          })

          await this.$http.post('/launch/buy/data/group/cid/remove', null, {
            params: {
              webSiteUrl: row.webSiteUrl
            }
          })

          this.$message.success('删除成功')
          if (this.cidGroups.length === 1 && this.pageNum > 1) {
            this.pageNum--
          }
          await this.fetchCidGroups()
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error(error.toString())
          }
        }
      },
      // 站点维护相关方法
      async fetchSiteMappingList() {
        try {
          this.siteLoading = true
          const params = {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }

          const response = await this.$http.get('/launch/site/advertiser/mapping/list', {
            params
          })

          if (response.data.header.code === 0) {
            this.siteMappingList = response.data.body.data || []
            this.total = response.data.body.total || 0
          } else {
            this.$message.error(response.data.header.msg || '获取数据失败')
          }
        } catch (error) {
          this.$message.error(error.toString() || '获取数据失败')
        } finally {
          this.siteLoading = false
        }
      },
      resetSiteAddForm() {
        this.siteAddForm.items = [{ webSiteUrl: '', fakeWebSiteUrl: '', advertiserId: '', isInvalid: false, invalidReason: '' }]
      },
      addSiteAddItem(count) {
        for (let i = 0; i < count; i++) {
          this.siteAddForm.items.push({
            webSiteUrl: '',
            fakeWebSiteUrl: '',
            advertiserId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      removeSiteAddItem(index) {
        this.siteAddForm.items.splice(index, 1)
        // 如果删除后没有数据了，至少保留一行
        if (this.siteAddForm.items.length === 0) {
          this.siteAddForm.items.push({
            webSiteUrl: '',
            fakeWebSiteUrl: '',
            advertiserId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      // 清除校验错误标记
      clearValidationErrors() {
        this.siteAddForm.items.forEach(item => {
          item.isInvalid = false
          item.invalidReason = ''
        })
        this.siteEditForm.items.forEach(item => {
          item.isInvalid = false
          item.invalidReason = ''
        })
      },
      // 校验站点映射关系保存
      async checkSiteMappingSave(id, items) {
        try {
          const response = await this.$http.post('/launch/site/advertiser/mapping/checkSave', {
            id: id || undefined,
            item: items
          })

          if (response.data.header.code === 0) {
            return {
              valid: response.data.body.data.valid,
              invalidItems: response.data.body.data.invalidItems || []
            }
          } else {
            throw new Error(response.data.header.msg || '校验失败')
          }
        } catch (error) {
          throw error
        }
      },
      // 标记校验失败的行
      markInvalidItems(items, invalidItems) {
        // 先清除所有标记
        items.forEach(item => {
          item.isInvalid = false
          item.invalidReason = ''
        })
        
        // 遍历所有 items，通过内容匹配找到对应的无效项
        items.forEach(item => {
          // 获取 trim 后的值用于匹配
          const trimmedWebSiteUrl = item.webSiteUrl?.trim() || ''
          const trimmedFakeWebSiteUrl = item.fakeWebSiteUrl?.trim() || ''
          const trimmedAdvertiserId = item.advertiserId?.trim() || ''
          
          // 查找匹配的无效项（使用 trim 后的值进行比较）
          const invalidItem = invalidItems.find(invalid => 
            (invalid.webSiteUrl || '') === trimmedWebSiteUrl &&
            (invalid.fakeWebSiteUrl || '') === trimmedFakeWebSiteUrl &&
            (invalid.advertiserId || '') === trimmedAdvertiserId
          )
          
          if (invalidItem) {
            item.isInvalid = true
            item.invalidReason = invalidItem.reason || '校验不通过'
          }
        })
      },
      async handleSiteAddSubmit() {
        try {
          // 清除之前的校验错误
          this.clearValidationErrors()

          // 校验数据（伪装域名不做必填校验）
          const validItems = this.siteAddForm.items.filter(item =>
            item.webSiteUrl && item.advertiserId
          )

          if (validItems.length === 0) {
            this.$message.error('请至少填写一条完整的映射关系（站点名称和账户ID为必填项）')
            return
          }

          // 检查是否有未填写完整的行（伪装域名不做必填校验）
          const incompleteItems = this.siteAddForm.items.filter(item =>
            (item.webSiteUrl || item.fakeWebSiteUrl || item.advertiserId) &&
            (!item.webSiteUrl || !item.advertiserId)
          )

          if (incompleteItems.length > 0) {
            this.$message.error('请填写完整的站点名称和账户ID（伪装域名为选填项）')
            return
          }

          this.siteAddSubmitting = true

          // 准备提交的数据（伪装域名可以为空）
          const mappingList = validItems.map(item => ({
            webSiteUrl: item.webSiteUrl.trim(),
            fakeWebSiteUrl: item.fakeWebSiteUrl ? item.fakeWebSiteUrl.trim() : '',
            advertiserId: item.advertiserId.trim()
          }))

          // 前置校验
          const checkResult = await this.checkSiteMappingSave(undefined, mappingList)
          
          if (!checkResult.valid) {
            // 标记校验失败的行
            this.markInvalidItems(this.siteAddForm.items, checkResult.invalidItems)
            this.$message.warning('数据校验不通过，请检查红色标记的行')
            this.siteAddSubmitting = false
            return
          }

          // 批量提交
          const response = await this.$http.post('/launch/site/advertiser/mapping/save', mappingList)

          if (response.data.header.code === 0) {
            this.$message.success(`成功新增 ${mappingList.length} 条映射关系`)
            this.siteAddDialogVisible = false
            this.resetSiteAddForm()
            await this.fetchSiteMappingList()
          } else {
            this.$message.error(response.data.header.msg || '新增失败')
          }
        } catch (error) {
          this.$message.error(error.response?.data?.header?.msg || error.message || '新增失败')
        } finally {
          this.siteAddSubmitting = false
        }
      },
      async handleSiteEdit(row) {
        try {
          this.editingSiteMappingId = row.id
          this.siteEditDialogVisible = true

          // 获取详情数据
          const response = await this.$http.get('/launch/site/advertiser/mapping/detail', {
            params: {
              id: row.id
            }
          })

          if (response.data.header.code === 0) {
            const detailData = response.data.body.data || []
            this.siteEditForm.id = row.id
            this.siteEditForm.items = detailData.map(item => ({
              webSiteUrl: item.webSiteUrl,
              fakeWebSiteUrl: item.fakeWebSiteUrl,
              advertiserId: item.advertiserId,
              isInvalid: false,
              invalidReason: ''
            }))
          } else {
            this.$message.error(response.data.header.msg || '获取详情失败')
          }
        } catch (error) {
          this.$message.error(error.toString() || '获取详情失败')
        }
      },
      removeSiteEditItem(index) {
        this.siteEditForm.items.splice(index, 1)
        // 如果删除后没有数据了，至少保留一行
        if (this.siteEditForm.items.length === 0) {
          this.siteEditForm.items.push({
            webSiteUrl: '',
            fakeWebSiteUrl: '',
            advertiserId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      addSiteEditItem(count) {
        // 获取第一条数据的站点名称和伪装域名
        const firstItem = this.siteEditForm.items[0]
        const webSiteUrl = firstItem?.webSiteUrl || ''
        const fakeWebSiteUrl = firstItem?.fakeWebSiteUrl || ''

        for (let i = 0; i < count; i++) {
          this.siteEditForm.items.push({
            webSiteUrl: webSiteUrl,
            fakeWebSiteUrl: fakeWebSiteUrl,
            advertiserId: '',
            isInvalid: false,
            invalidReason: ''
          })
        }
      },
      resetSiteEditForm() {
        this.$refs.siteEditForm?.resetFields()
        this.siteEditForm.id = null
        this.siteEditForm.items = []
        this.editingSiteMappingId = null
      },
      async handleSiteEditSubmit() {
        try {
          // 清除之前的校验错误
          this.clearValidationErrors()

          // 校验：编辑时只允许输入同一站点名称
          if (this.siteEditForm.items.length === 0) {
            this.$message.error('至少需要保留一条映射关系')
            return
          }

          const webSiteUrls = this.siteEditForm.items.map(item => item.webSiteUrl).filter(url => url)
          const uniqueWebSiteUrls = [...new Set(webSiteUrls)]

          if (uniqueWebSiteUrls.length > 1) {
            this.$message.error('编辑时只允许输入同一站点名称')
            return
          }

          if (webSiteUrls.length === 0) {
            this.$message.error('请输入站点名称')
            return
          }

          // 校验必填字段（伪装域名不做必填校验）
          for (const item of this.siteEditForm.items) {
            if (!item.webSiteUrl || !item.advertiserId) {
              this.$message.error('请填写完整的站点名称和账户ID（伪装域名为选填项）')
              return
            }
          }

          this.siteEditSubmitting = true

          // 准备提交的数据（伪装域名可以为空）
          const items = this.siteEditForm.items.map(item => ({
            webSiteUrl: item.webSiteUrl.trim(),
            fakeWebSiteUrl: item.fakeWebSiteUrl ? item.fakeWebSiteUrl.trim() : '',
            advertiserId: item.advertiserId.trim()
          }))

          // 前置校验
          const checkResult = await this.checkSiteMappingSave(this.siteEditForm.id, items)
          
          if (!checkResult.valid) {
            // 标记校验失败的行
            this.markInvalidItems(this.siteEditForm.items, checkResult.invalidItems)
            this.$message.warning('数据校验不通过，请检查红色标记的行')
            this.siteEditSubmitting = false
            return
          }

          const response = await this.$http.post('/launch/site/advertiser/mapping/update', {
            id: this.siteEditForm.id,
            item: items
          })

          if (response.data.header.code === 0) {
            this.$message.success('更新成功')
            this.siteEditDialogVisible = false
            this.resetSiteEditForm()
            await this.fetchSiteMappingList()
          } else {
            this.$message.error(response.data.header.msg || '更新失败')
          }
        } catch (error) {
          this.$message.error(error.response?.data?.header?.msg || error.message || '更新失败')
        } finally {
          this.siteEditSubmitting = false
        }
      },
      async handleSiteDelete(row) {
        try {
          await this.$confirm('确认删除该站点映射关系吗？', '提示', {
            type: 'warning'
          })

          const response = await this.$http.post('/launch/site/advertiser/mapping/delete', null, {
            params: {
              id: row.id
            }
          })

          if (response.data.header.code === 0) {
            this.$message.success('删除成功')
            if (this.siteMappingList.length === 1 && this.pageNum > 1) {
              this.pageNum--
            }
            await this.fetchSiteMappingList()
          } else {
            this.$message.error(response.data.header.msg || '删除失败')
          }
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error(error.response?.data?.header?.msg || error.message || '删除失败')
          }
        }
      },
      // 获取新增表格行的类名
      getSiteAddRowClassName({ row, rowIndex }) {
        if (row.isInvalid) {
          return 'invalid-row'
        }
        return ''
      },
      // 获取新增表格单元格的类名
      getSiteAddCellClassName({ row, column, rowIndex, columnIndex }) {
        // 不需要在单元格级别添加类名，错误样式已经在输入框级别处理
        return ''
      },
      // 获取编辑表格行的类名
      getSiteEditRowClassName({ row, rowIndex }) {
        if (row.isInvalid) {
          return 'invalid-row'
        }
        return ''
      },
      // 获取编辑表格单元格的类名
      getSiteEditCellClassName({ row, column, rowIndex, columnIndex }) {
        // 不需要在单元格级别添加类名，错误样式已经在输入框级别处理
        return ''
      },
    },
    created() {
      if (this.userType == 2) {
        this.activeTab = 'buyer'
        this.total = 0;
        this.fetchCategoryNameList()
        this.fetchBuyingSiteGroups()
      } else {
        this.fetchData()
      }
    },
    watch: {
      activeTab: {
        immediate: true,
        handler(newVal) {
          this.pageNum = 1
          this.sid = ''
          this.total = 0;
          if (newVal === 'buyer') {
            this.fetchCategoryNameList()
            this.fetchBuyingSiteGroups()
          } else if (newVal === 'cid') {
            this.fetchCidGroups()
          } else if (newVal === 'site') {
            this.fetchSiteMappingList()
          } else {
            this.fetchData()
          }
        }
      }
    }
  }
</script>

<style scoped>
  .data-groups {
    background-color: #f5f7fa;
    min-height: calc(100vh - 60px);
  }

  .header {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }

  .header-controls {
    position: relative;
  }

  .control-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }

  .site-action-container {
    display: flex;
    align-items: center;
  }

  .content-wrapper {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  /* Element UI 组件样式覆盖 */
  :deep(.el-tabs__header) {
    margin-bottom: 0;
  }

  :deep(.el-table) {
    margin-top: 20px;
  }

  :deep(.el-table th) {
    background-color: #f5f7fa;
    color: #606266;
  }

  :deep(.el-button--text) {
    padding: 0 8px;
  }

  /* 校验失败的行样式 - 移除整行背景色，只保留输入框的错误样式 */
  :deep(.invalid-row) {
    background-color: #fff !important;
  }

  :deep(.invalid-row:hover) {
    background-color: #f5f7fa !important;
  }

  /* 输入框包装器 */
  .input-wrapper {
    width: 100%;
  }

  /* 带错误信息的输入框包装器 - 使用 flex 布局让输入框和错误信息在同一行 */
  .input-with-error {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .input-with-error .el-input {
    flex: 1;
    min-width: 0;
  }

  /* 校验失败的输入框样式 - 只影响输入框本身 */
  .invalid-input :deep(.el-input__inner) {
    border-color: #f56c6c !important;
    background-color: #fff;
  }

  .invalid-input :deep(.el-input__inner):focus {
    border-color: #f56c6c !important;
    box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
  }

  /* 校验失败原因提示 - 默认样式（下方显示） */
  .invalid-reason {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.4;
    padding: 0;
    white-space: normal;
    word-break: break-word;
  }

  /* 内联错误信息 - 显示在输入框右侧 */
  .invalid-reason.inline-error {
    margin-top: 0;
    flex-shrink: 0;
    white-space: nowrap;
    font-size: 12px;
    color: #f56c6c;
  }

  /* 确保表格单元格内容正确对齐和布局 */
  :deep(.el-table td) {
    padding: 8px 0;
    vertical-align: top;
    background-color: #fff !important;
  }

  :deep(.el-table .cell) {
    padding: 0 10px;
    word-break: break-word;
  }

  /* 确保表格单元格边框正常显示，不受错误状态影响 */
  :deep(.el-table--border td) {
    border-color: #EBEEF5 !important;
  }

  :deep(.invalid-row td) {
    border-color: #EBEEF5 !important;
  }

  /* 确保输入框在单元格内正确显示 */
  :deep(.el-table .cell .el-input) {
    width: 100%;
  }

  /* 响应式处理 */
  @media screen and (max-width: 768px) {
    .control-buttons {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }

    .el-input {
      width: 100% !important;
    }
  }
</style> 